var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "665px",
    height: "196px",
    viewBox: "0 0 665 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval + Oval Copy + Oval Copy 2 Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1174,
    height: 535
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log-in",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "app.ferritico.com-logged-out",
    transform: "translate(0.000000, -566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-+-Oval-Copy-+-Oval-Copy-2-Mask",
    transform: "translate(0.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.948505,677 C439.719295,677 664.897011,611.468015 664.897011,530.630215 C664.897011,470.856673 518.86543,409.708193 330.463759,381.899305 C264.070814,372.099424 64.2943259,362.108117 4.43409003,341.253382 C-184.870573,275.301441 -341,449.792414 -341,530.630215 C-341,611.468015 -115.822284,677 161.948505,677 Z",
    id: "Oval",
    fill: "#048ABF",
    fillRule: "nonzero",
    opacity: 0.35,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.258363,667.518584 C432.438858,667.518584 591.962125,593.362459 591.962125,519.904061 C591.962125,446.445662 432.438858,419 157.258363,419 C84.8021507,419 1.80408085,397.620355 -60.3065721,403.256882 C-234.085151,419.027247 -341,480.393903 -341,534.510388 C-341,607.968786 -117.922132,667.518584 157.258363,667.518584 Z",
    id: "Oval-Copy",
    fill: "#048ABF",
    fillRule: "nonzero",
    opacity: 0.35,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8310035,680.518584 C329.324681,680.518584 467.580449,606.362459 467.580449,532.904061 C467.580449,459.445662 329.324681,442 90.8310035,442 C-147.662674,442 -341,474.05199 -341,547.510388 C-341,620.968786 -147.662674,680.518584 90.8310035,680.518584 Z",
    id: "Oval-Copy-2",
    fill: "#048ABF",
    fillRule: "nonzero",
    opacity: 0.35,
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpBackground);
export default __webpack_public_path__ + "static/media/Sign-up-background.d69378ceb366f2f084de659cd038179f.svg";
export { ForwardRef as ReactComponent };